import { render, staticRenderFns } from "./InputDueDate.vue?vue&type=template&id=45c5ea62&"
import script from "./InputDueDate.vue?vue&type=script&lang=js&"
export * from "./InputDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports